import { useState } from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import { BulkDeleteTasksDocument } from 'generated/resources/graphql'
import { DocumentNode } from 'graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { DeleteTaskModal } from 'modules/tasks/components/DeleteTaskModal'

interface Props {
  ids: number[]
  refetchQueries?: DocumentNode[]
}

export const DeleteButton = ({ ids, refetchQueries }: Props) => {
  const [openModal, setOpenModal] = useState(false)
  const [deleteTask, { loading }] = useMutation(BulkDeleteTasksDocument, {
    extractorFn: (data) => data.tasksMutations.bulkDeleteTasksTask,
  })

  const setFlashMessage = (message: string, type: 'correct' | 'wrong') => {
    app.setFlash({
      type,
      message,
      time: 2000,
    })
  }

  const deleteTasks = async () => {
    const result = await deleteTask({
      variables: { ids },
      refetchQueries,
    })
    const handled = handleResult(result, () => undefined)
    if (handled.success) {
      setFlashMessage(i18n.t('tasks.flash_messages.bulk_delete_correct'), 'correct')
    } else {
      setFlashMessage(i18n.t('tasks.flash_messages.bulk_delete_error'), 'wrong')
    }
  }

  const onOpenModal = () => {
    setOpenModal(true)
  }

  const onCloseModal = () => {
    setOpenModal(false)
  }

  return (
    <>
      {openModal && <DeleteTaskModal onClose={onCloseModal} onSubmit={deleteTasks} />}
      <Button
        disabled={loading}
        aria-label={i18n.t('tasks.actions.delete')}
        type="secondary"
        onClick={onOpenModal}
        iconName="delete"
      />
    </>
  )
}
